import { render, staticRenderFns } from "./SponsorTeam.vue?vue&type=template&id=8dda9634&"
import script from "./SponsorTeam.vue?vue&type=script&lang=js&"
export * from "./SponsorTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports